import { Component, Prop } from 'vue-property-decorator';
import TombolaBaseComponent from '@/components/base/base.component';
import { UserPreferences } from '@/app-modules/store/modules/user-preferences';
import { Chrome } from 'vue-color';
import { mixin as clickaway } from 'vue-clickaway2';

@Component({
  name: 'CMChatColourComponent',
  components: {
    colourpicker: Chrome
  },
  mixins: [clickaway]
})

export default class CMChatColourComponent extends TombolaBaseComponent {
  @Prop() private userPreferences: UserPreferences;
  private cmChatColour: string = '';
  private displayPicker: boolean = false;
  private colours: any = {};

  protected async created() {
    this.colours.hex = this.userPreferences.cmChatColour;
  }

  public saveSettings() {
    this.userPreferences.cmChatColour = this.colours.hex;
  }

  private toggleDisplayPicker() {
    this.displayPicker ? this.hidePicker() : this.showPicker();
  }

  private showPicker() {
    this.displayPicker = true;
  }

  private hidePicker() {
    this.displayPicker = false;
  }


}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/user-settings/_components/cm-chat-colour/cm-chat-colour.component.ts